import { Ref } from "react";
import { WebApiRequest, HTTP_GET } from "tools/webservice";
import { ComparisonChartField } from "interfaces/Mueller.Business.Models";

export const getComparisonChartFields = (controlNumber: number, successCallback: (response: ComparisonChartField[]) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/comparison-chart/${controlNumber}`,
  successCallback,
  errorCallback,
  mountedRef
});